import { Flex, Link, Text } from '@chakra-ui/react';
import moment from 'moment';
import AppCard from 'presentation/components/shared/card/AppCard';
import CardInfoRow from 'presentation/components/shared/card/CardInfoRow';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import isValidUrl from 'utils/isValidUrl';
import nFormatter from 'utils/nFormatter';

interface Props {
  company: PeCompanyDetail;
}

const PeCompanyMainDetailsSection: FC<Props> = ({ company }) => {
  const { t } = useTranslation();

  const infoRowWidth = 'calc(50% - 10px)';

  return (
    <>
      <GridHeading>{t('peCompanyDetails')}</GridHeading>
      <AppCard px="20px" pt="10px" pb="15px">
        <Flex flexWrap="wrap" justifyContent="space-between">
          {company.foundationDate && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyFoundationDate')}>
              <Text>{moment(company.foundationDate).format('L')}</Text>
            </CardInfoRow>
          )}
          {company.employeesTotal && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyEmployees')}>
              <Text>{company.employeesTotal}</Text>
            </CardInfoRow>
          )}
          {company.headOffice && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyHeadOffice')}>
              <Text>{company.headOffice}</Text>
            </CardInfoRow>
          )}
          {company.businessModel && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyBusinessModel')}>
              <Text>{company.businessModel}</Text>
            </CardInfoRow>
          )}
          {company.sector && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanySector')}>
              <Text>{company.sector}</Text>
            </CardInfoRow>
          )}
          {company.takeoverTotal && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyTakeovers')}>
              <Text>{company.takeoverTotal}</Text>
            </CardInfoRow>
          )}
          {company.industry && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyIndustry')}>
              <Text>{company.industry}</Text>
            </CardInfoRow>
          )}
          {company.website && isValidUrl(company.website) && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyWebsite')}>
              <Link
                flex="1"
                textAlign="right"
                maxW="48%"
                href={company.website}
                isExternal
              >
                {new URL(company.website).host}
              </Link>
            </CardInfoRow>
          )}
          {company.revenue && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyRevenue')}>
              <Text>
                {`${nFormatter(company.revenue, 0)} ${company.currency.symbol}`}
              </Text>
            </CardInfoRow>
          )}
          {company.estimate && (
            <CardInfoRow w={infoRowWidth} label={t('peCompanyValue')}>
              <Text>{company.estimate}</Text>
            </CardInfoRow>
          )}
        </Flex>
      </AppCard>
    </>
  );
};

export default PeCompanyMainDetailsSection;
